import { useEffect, useState } from 'react';
import { CognitoUser } from 'amazon-cognito-identity-js';

export const useUserId = (user: CognitoUser | null) => {
  const [userId, setUserId] = useState<string | null>(null);

  useEffect(() => {
    if (user) {
      user.getUserAttributes((err, attributes) => {
        if (err) {
          console.error('Failed to get user attributes', err);
        } else {
          const userIdFromAttributes = attributes?.find(attr => attr.Name === 'sub')?.Value;
          if (userIdFromAttributes) {
            setUserId(userIdFromAttributes);
          }
        }
      });
    }
  }, [user]);

  return userId;
};
